/**
 * NHS number validation.
 *
 * Mirrors the backend's app/utils/nhs_validation.py so the browser rejects the same
 * values the API does. SignatureRx applies this identical modulus-11 check and refuses
 * a prescription patient outright on failure, so a length-only check just defers the
 * error to a place the user can no longer fix it.
 */
export const normalizeNhsNumber = (value?: string | null): string =>
  (value || '').replace(/\D/g, '');

export const isValidNhsNumber = (value?: string | null): boolean => {
  const digits = normalizeNhsNumber(value);
  if (digits.length !== 10) return false;

  let total = 0;
  for (let i = 0; i < 9; i += 1) {
    total += parseInt(digits[i], 10) * (10 - i);
  }
  let check = 11 - (total % 11);
  if (check === 11) check = 0;
  if (check === 10) return false;
  return check === parseInt(digits[9], 10);
};
